import { Button, Header, Popup } from '../Generic'
import { useState } from 'react'
import './VideoIdAfterCancelPopup.css'
import { actionReport } from '@methods/actionReport'
import { Illustration } from '../Illustration/Illustration'

interface VideoIdAfterCancelPopupProps {
  title: string
  thankYouForYourFeedback: string
  sendButtonText: string
  cancelButtonText: string
  visibility: boolean
  handleVisibility: () => void
}

export const VideoIdAfterCancelPopup = ({
  title,
  thankYouForYourFeedback,
  sendButtonText,
  cancelButtonText,
  visibility,
  handleVisibility,
}: VideoIdAfterCancelPopupProps) => {
  const [feedback, setFeedback] = useState<string>()
  const [feedbackSent, setFeedbackSent] = useState<boolean>(false)
  const [closeOngoing, setCloseOngoing] = useState<boolean>(false)

  const handleProceed = () => {
    setCloseOngoing(true)

    try {
      actionReport({
        type: 'event.onboarding-web.eidv.CANCEL_SURVEY',
        payload: {
          feedback,
        },
      })
      setFeedbackSent(true)

      //eslint-disable-next-line
    } catch (error) {}

    setTimeout(() => {
      handleVisibility()
    }, 2000)
  }

  const handleClose = () => {
    setCloseOngoing(true)
    handleVisibility()
  }

  return feedbackSent ? (
    <Popup
      visibility={visibility}
      handleVisibility={handleVisibility}
      closeIconHidden={true}
      clickOutsideEnabled={!closeOngoing}
      className="feedback-popup"
    >
      <div className="feedback-popup-centered">
        <Illustration type="heart" />

        <Header>{thankYouForYourFeedback}</Header>
      </div>
    </Popup>
  ) : (
    <Popup
      visibility={visibility}
      handleVisibility={handleClose}
      closeIconHidden={true}
      clickOutsideEnabled={!closeOngoing}
      title={title}
      className="feedback-popup"
      footer={
        <>
          <Button
            onClick={handleClose}
            onKeyDown={handleClose}
            disabled={closeOngoing}
            className="button--secondary feedback-popup__button"
          >
            {cancelButtonText}
          </Button>
          <Button
            onClick={handleProceed}
            onKeyDown={handleProceed}
            disabled={!feedback || closeOngoing}
            className="feedback-popup__button"
          >
            {sendButtonText}
          </Button>
        </>
      }
    >
      <textarea
        className="feedback-popup__textarea"
        name="feedback"
        rows={6}
        onChange={(e) => setFeedback(e.target.value)}
      />
    </Popup>
  )
}
